import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  products: [],
  product: {},
  totalProducts: 0
};

const getters = {};

const actions = {
  LOAD_PRODUCT: function({ commit, rootState }, payload) {
    return Vue.prototype.$axios.get("suppliers/"+rootState.auth.user.usupplier +"/products/" + payload.productId).then(
      response => {
        commit("SET_PRODUCT", response.data.product);
      },
      err => {
        throw new Error(err);
      }
    );
  },
  LOAD_PRODUCTS: async function({ commit, rootState }, payload) {
    let idQuery = payload.id ? "&id=" + payload.id : "";
    let supplierIdQuery = payload.supplierId
      ? "&supplierId=" + payload.supplierId
      : "";
    let productNameQuery = payload.productName
      ? "&product_name=" + payload.productName
      : "";

    let productIdQuery = payload.productId
      ? "&productId=" + payload.productId
      : "";

    let productBrandQuery = payload.brandId
      ? "&brandId=" + payload.brandId
      : "";

    let productStatusQuery = payload.statusId
      ? "&statusId=" + payload.statusId
      : "";
    let shipmentProfileIdQuery = payload.shipmentProfileId
      ? "&shipmentProfileId=" + payload.shipmentProfileId
      : "";

    return await Vue.prototype.$axios
      .get(
        "suppliers/"+rootState.auth.user.usupplier +
        "/products?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          idQuery +
          supplierIdQuery +
          productNameQuery +
          productIdQuery +
          productBrandQuery +
          productStatusQuery +
          shipmentProfileIdQuery
      )
      .then(
        response => {
          commit("SET_PRODUCTS", response.data.products);
          commit("SET_TOTAL_PRODUCTS", response.data.meta.total);
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  },
  UPDATE_PRODUCT_APPROVED_STATUS: function(
    { commit, rootState, dispatch },
    payLoad
  ) {
    return Vue.prototype.$axios
      .patch(
        "suppliers/"+rootState.auth.user.usupplier +
        "/prooducts/" + payLoad.productId,
        {
          approved: payLoad.approved
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(
        response => {},
        err => {
          throw new Error(err.response.data.meta.message);
        }
      );
  },
  CREATE_PRODUCT: function({ commit, dispatch, rootState }, payload) {
    return Vue.prototype.$axios.post("suppliers/"+rootState.auth.user.usupplier + "/products", payload).then(
      response => {
        Vue.prototype.$swal({
          title: "Success",
          html: "Product has been added",
          icon: "info"
        });
      },
      err => {
        throw new Error(err.response.data.meta.message);
      }
    );
  },
  UPDATE_PRODUCT: function({ commit, rootState, dispatch }, payload) {
    return Vue.prototype.$axios.post("suppliers/"+rootState.auth.user.usupplier + "/products/" + payload.id, payload).then(
      response => {
        Vue.prototype.$swal({
          title: "Success",
          html: "Product has been updated",
          icon: "info"
        });
      },
      err => {
        throw new Error(err.response.data.meta.message);
      }
    );
  },
  DESTROY_PRODUCT: function({ commit }, payload) {
    return Vue.prototype.$axios.delete("suppliers/"+rootState.auth.user.usupplier + "/products/" + payload).then(
      response => {},
      err => {
        throw new Error(err.response.data.meta.message);
      }
    );
  }
};

const mutations = {
  SET_PRODUCTS: (state, products) => {
    state.products = products;
  },
  SET_TOTAL_PRODUCTS: (state, totalProducts) => {
    state.totalProducts = totalProducts;
  },
  SET_PRODUCT: (state, product) => {
    state.product = product;
    state.product.productSubcategories = state.product.subCategories.map(
      a => a.id
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
